/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postNotificationsBroadcastmessage } from '../fn/notification/post-notifications-broadcastmessage';
import { PostNotificationsBroadcastmessage$Params } from '../fn/notification/post-notifications-broadcastmessage';
import { postNotificationsDatachanged } from '../fn/notification/post-notifications-datachanged';
import { PostNotificationsDatachanged$Params } from '../fn/notification/post-notifications-datachanged';


/**
 * Controller for handling notifications and broadcasting messages via SignalR.
 */
@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postNotificationsDatachanged()` */
  static readonly PostNotificationsDatachangedPath = '/notifications/DataChanged';

  /**
   * Send a data change notification to all clients.
   *
   * Send a data change notification to all clients.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotificationsDatachanged()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postNotificationsDatachanged$Response(params?: PostNotificationsDatachanged$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postNotificationsDatachanged(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Send a data change notification to all clients.
   *
   * Send a data change notification to all clients.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNotificationsDatachanged$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postNotificationsDatachanged(params?: PostNotificationsDatachanged$Params, context?: HttpContext): Observable<void> {
    const resp = this.postNotificationsDatachanged$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postNotificationsBroadcastmessage()` */
  static readonly PostNotificationsBroadcastmessagePath = '/notifications/BroadcastMessage';

  /**
   * Broadcast a message to all clients.
   *
   * Broadcast a message to all clients.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotificationsBroadcastmessage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postNotificationsBroadcastmessage$Response(params?: PostNotificationsBroadcastmessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postNotificationsBroadcastmessage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Broadcast a message to all clients.
   *
   * Broadcast a message to all clients.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNotificationsBroadcastmessage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postNotificationsBroadcastmessage(params?: PostNotificationsBroadcastmessage$Params, context?: HttpContext): Observable<void> {
    const resp = this.postNotificationsBroadcastmessage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
